'use client';
import createIconSet from './createIconSet';
import font from './vendor/react-native-vector-icons/Fonts/Entypo.ttf';
import glyphMap from './vendor/react-native-vector-icons/glyphmaps/Entypo.json';
export default createIconSet(glyphMap, 'entypo', font);
//# sourceMappingURL=Entypo.js.map